import React from "react";
import { Route, Routes } from "react-router-dom";
import Overview from "./Overview";
import Sidebar from "./Sidebar";
import styles from "./Sidebar.module.css";

const MainRoutes = () => {
  return (
    <>
      <Sidebar />
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route
          path="*"
          element={
            <div className={styles.noshow}>
              <h3>Page is Under Maintainance</h3>
              <img
                style={{ marginTop: "-20px" }}
                width="60%"
                src="https://media.istockphoto.com/id/1283050796/vector/flat-design-under-construction-concept.jpg?s=612x612&w=0&k=20&c=CATQe8sEl7YdpwxZ4VHwYh5FjHY9MkbyRNhALyslZwA="
                alt=""
              />
            </div>
          }
        />
      </Routes>
    </>
  );
};

export default MainRoutes;
